import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { gameHeader } from 'app/constants/table-header-constants';
import useGameManagement from './useGameManagement';

const GameManagement = () => {
  const {
    isdeleteFiltering,
    totalNumber,
    filteredData,
    sectionObj,
    handleDelete,
    handleEdit,
    handleViewLeaderboard,
    inputChangeHandler,
    changeHandler,
    pageLoading,
    fetchGameData,
    currentPage,
    dataPerPage,
    pageCount,
    paginationHandler,
    navigate,
  } = useGameManagement();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={gameHeader}
          data={filteredData}
          fetchData={fetchGameData}
          fulldata={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          paginationHandler={paginationHandler}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleViewLeaderboard={handleViewLeaderboard}
          handleNew={() => {}}
          inputChangeHandler={inputChangeHandler}
          changeHandler={changeHandler}
          pageLoading={pageLoading}
          navigate={navigate}
          isdeleteFiltering={isdeleteFiltering}
        />
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default GameManagement;
